import { EditorProvider } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import MenuBar from './components/MenuBar'

const extensions = [StarterKit]

const Tiptap = ({
  currentText = '',
  initialValue,
  onChange,
  limitOfCharacters = 1000,
  isViewportWidth = false,
  setComandsTiptap = () => {},
  style = {}
}) => {
  return (
    <div>
      <div
        className="border rounded"
        style={
          isViewportWidth
            ? {
                width: '100vh',
              }
            : style
        }
      >
        <EditorProvider
          extensions={extensions}
          content={initialValue}
          slotBefore={<MenuBar />}
          onUpdate={(props) => {
            setComandsTiptap(props?.editor?.commands)
            onChange(props?.editor?.getHTML())
          }}
        />
      </div>
      <div className="d-flex justify-content-end align-items-center text-bg-CTA-primary-disabled">
        <span>{`${currentText?.length}/${limitOfCharacters}`}</span>
      </div>
    </div>
  )
}

export default Tiptap
